module.exports = __webpack_public_path__ + "img/Eventos.c9f60371.png";